import styled from 'styled-components';
import { DEVICE } from '@app/styles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LogoImage = styled.img<any>`
  width: 74px;

  @media ${DEVICE.laptop} {
    width: 50px;
  }
`;
